export function FeedIcon({ className }: { className?: string }) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M13.3333 2.5H4.16667C3.25 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V6.66667L13.3333 2.5ZM15.8333 15.8333H4.16667V4.16667H12.5V7.5H15.8333V15.8333ZM5.83333 14.1667H14.1667V12.5H5.83333V14.1667ZM10 5.83333H5.83333V7.5H10V5.83333ZM5.83333 10.8333H14.1667V9.16667H5.83333V10.8333Z"
        fill="currentColor"
      />
    </svg>
  )
}
